import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import client from '../Contentful_API/api';
import CustomDataInfo from './CustomData'

class RecentCustomRevenue extends Component {

    state = {
        customrevenuecollections: [],
        searchString: ''
    }
    constructor() {
        super()
        this.getCustomRevenueData()
    }
    getCustomRevenueData = () => {
        client.getEntries({
            content_type: 'customrevenuecollections',
            query: this.state.searchString,
            limit: 4
        })
        .then((response) => {
            this.setState({customrevenuecollections: response.items})
            console.log(this.state.customrevenuecollections)
        })
        .catch((error) => {
          console.log("Error occurred while fetching Entries")
          console.error(error)
        })
    }

    render() {
        return (
            <div>
                { this.state.customrevenuecollections ? (
                    <div>
                        <Grid container spacing={2} style={{padding: 24}}>
                            { this.state.customrevenuecollections.map(dd => (
                               <Grid item xs={12} sm={3} lg={3} xl={3}>
                                    <CustomDataInfo customrevenuecollections={dd} />
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                ) : "No Custom revenue Data found" }
            </div>
        )
    }
}

export default RecentCustomRevenue;